import { FlowAuthType } from "../enums/FlowAuthType";
import { FlowProviderName } from "../enums/FlowProviderName";
import { StreamGrouping } from "../enums/StreamGrouping";

// export const useDummyFlowStream = FlowProviderName.lazada; // lazada OR storehub OR false
// export const useDummyFlowStream = FlowProviderName.storehub; // lazada OR storehub OR false
export const useDummyFlowStream = false; // lazada OR storehub OR false

export const flowStreamStorehub = {
    id: 1,
    flow_provider: {
        id: 1,
        name: "Storehub POS",
        short_name: FlowProviderName.storehub,
        authentication: FlowAuthType.HTTP_BASIC,
    },
    ext_id: "storehub123",
    ext_name: "StoreHub Hubble 1",
    auto_sync: true,
    auto_create_invoice: false,
    contact_id: 1,
    grouping: StreamGrouping.ALL,
    username: "bukku",
    password: "thisIsMyPassword",
    sync_starts_at: "2023-01-10 08:00:00",
    sync_ends_at: "2023-01-10 23:59:59",
    created_at: "2023-01-05 08:45:00",
    updated_at: "2023-01-08 11:20:00",
    // can_sync: true,
};

export const flowStreamLazada = {
    id: 1,
    flow_provider: {
        id: 2,
        name: "Lazada Ecom",
        short_name: FlowProviderName.lazada,
        authentication: FlowAuthType.OAUTH2,
    },
    ext_id: "lazada123",
    ext_name: "Lazada Shop 1",
    auto_sync: true,
    auto_create_invoice: true,
    // contact_id: 1,
    grouping: StreamGrouping.PRODUCT,
    username: null,
    password: null,
    sync_starts_at: "2024-01-26 08:00:00",
    sync_ends_at: "2023-02-15 23:59:59",
    created_at: "2024-01-26 12:00:00",
    updated_at: "2024-01-26 13:00:00",
    // can_sync: true,
};
